import { useKeycloak } from "@react-keycloak/web";
import React, { createContext, useEffect, useState } from "react";
import useAirlineAdminApi from "./api/useAirlineAdminApi";
import { useFormData } from "../helpers/FormDataProvider";
import { useLogout } from "./LogoutProvider";
import Loader from "../components/element/Loader";

const StorageContext = createContext();

const StorageProvider = ({ children }) => {
  const { keycloak } = useKeycloak();
  const { userData } = useFormData();
  const { handleUnauthorized } = useLogout();
  const {
    fetchCommercialUserProfile,
    fetchListOfAirline,
    fetchListOfAirport,
    fetchListOfAssociatedAirline,
    fetchAARoles,
  } = useAirlineAdminApi(userData.isAAUser);
  const [userProfileData, setUserProfileData] = useState(null);
  const [aaRolesData, setAARolesData] = useState(null);
  const [airlineData, setAirlineData] = useState(null);
  const [associatedAirlineData, setAssociatedAirlineData] = useState(null);
  const [airportData, setAirportData] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      if (keycloak.authenticated && userData.isAAUser !== null) {
        try {
          const [userProfile, aaRoles, airline, airport, associatedAirline] =
            await Promise.all([
              fetchCommercialUserProfile(),
              userData.isAAUser ? fetchAARoles() : Promise.resolve(null),
              fetchListOfAirline(),
              fetchListOfAirport(),
              fetchListOfAssociatedAirline(),
            ]);

          setUserProfileData(userProfile);
          setAARolesData(aaRoles);
          setAirlineData(airline);
          setAirportData(airport);
          setAssociatedAirlineData(associatedAirline);
        } catch (err) {
          // Check if it's a 404 error from GET_COMMERCIAL_USER_PROFILE
          if (err.status === 404) {
            handleUnauthorized();
          } else {
            setError(err);
          }
        }
      }
    };

    fetchData();
  }, [keycloak.authenticated, userData]);

  if (
    keycloak.authenticated &&
    (!userProfileData || (userData.isAAUser && !aaRolesData))
  ) {
    return <Loader />;
  }

  return (
    <StorageContext.Provider
      value={{
        userProfileData,
        aaRolesData,
        airlineData,
        airportData,
        associatedAirlineData,
        setAirportData,
      }}
    >
      {children}
    </StorageContext.Provider>
  );
};

export { StorageContext, StorageProvider };
